import {
  hooks,
  Card,
  CardContent,
  Flex,
  Grid,
  Skeleton,
  SkeletonBox,
  BaseProps,
} from '@bitrise/bitkit';
import { TypeMetricKey } from '@trace/types';
import React, { useContext, FunctionComponent } from 'react';
import { useParams } from 'react-router-dom';
import { AttributesContext } from '../../Attributes/Attributes';
import MinMaxSync from '../../ViewVisualisations/Percentile/MinMaxChart/MinMaxSync';
import PerformanceDetailBreakdownCard from './PerformanceDetailBreakdownCard';

const DetailBreakdown: FunctionComponent<BaseProps> = (props) => {
  const { metric } = useParams<{ metric: TypeMetricKey }>();
  const match = hooks.useMediaQuery(['800px', '1056px']);
  const { attributes, isFetching, isFetched } = useContext(AttributesContext);

  return (
    <Skeleton {...props} active={isFetching}>
      <MinMaxSync key={metric}>
        <Grid gap="x6" grow repeat={match({ '1056px': 3, '800px': 2 }) || 1} repeatWidth="1fr">
          {!isFetched && isFetching
            ? Array.from({ length: 6 }).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Card key={index}>
                  <CardContent padding="x4">
                    <SkeletonBox height="24px" margin="x1" width="80px" />
                    <SkeletonBox height="16px" margin="x1" width="40px" />
                    <Flex height="240px" />
                  </CardContent>
                </Card>
              ))
            : attributes.map((attr, index) => (
                <PerformanceDetailBreakdownCard
                  animDelay={index * 100}
                  attribute={attr}
                  key={attr}
                />
              ))}
        </Grid>
      </MinMaxSync>
    </Skeleton>
  );
};

export default DetailBreakdown;
